import type { LoaderFunction } from 'react-router-dom';
import { apiGetMostMatchesWrestlerListStats } from "../../components/ui_components/ApiList";

export const MostFightsResponsiveLoader: LoaderFunction = async ({ request }) => {
    try {
        const url = new URL(request.url);
        const year = url.searchParams.get('year') || 'globale';

        const response = await apiGetMostMatchesWrestlerListStats(1, year, '');
        return response;
    } catch (error) {
        console.error('Loader error:', error);
        throw new Error('Failed to load data');
    }
};
